export const SET_PARTICLES_SIZE = 'SET_PARTICLES_SIZE';

export const SET_FILTER = 'SET_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';

export const SET_AGE = 'SET_AGE';